import { render, staticRenderFns } from "./VuesticIconSlower.vue?vue&type=template&id=6e10f0ce&"
import script from "./VuesticIconSlower.vue?vue&type=script&lang=js&"
export * from "./VuesticIconSlower.vue?vue&type=script&lang=js&"
import style0 from "./VuesticIconSlower.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticIconSlower.vue"
export default component.exports